import { useEffect, useState } from "react"
import EmployeeFormModal from "../../components/construction/EmployeeFormModal"
import CwDataTable from "../../components/construction/CwDataTable"
import CwPageHeader from "../../components/construction/CwPageHeader"
import CwAddButton from "../../components/construction/CwAddButton"
import CwRowActions from "../../components/construction/CwRowActions"
import { SageEmployee } from "../../Interfaces"
import { t } from "../../i18n"
import { displayEmployeeName } from "../../utils/sageCodes"

const seed: SageEmployee[] = [
  { id: 701, employeeNum: 42, firstName: "Ada", lastName: "Lovelace", jobDescription: "Foreman" },
  { id: 702, employeeNum: 43, firstName: "Alan", lastName: "Turing", jobDescription: "Carpenter" },
]

/**
 * Unauthenticated fixture for ConstructionWalk employee add/edit.
 * /preview/employees?product=construction
 */
export default function EmployeesPreview() {
  const params = new URLSearchParams(window.location.search)
  const [open, setOpen] = useState(params.get("modal") === "1" || params.get("edit") === "1")
  const [editing, setEditing] = useState<SageEmployee | null>(params.get("edit") === "1" ? seed[0] : null)

  useEffect(() => {
    document.documentElement.classList.add("construction-walk")
  }, [])

  return (
    <div className="min-h-screen p-4 md:p-8 bg-secondary-extra-light">
      <CwPageHeader
        title={t("employees.title")}
        subtitle="Valley Builders · VAL"
        action={<CwAddButton label={t("employees.add")} onClick={() => { setEditing(null); setOpen(true) }} />}
      />
      <CwDataTable
        columns={[
          { key: "employeeNum", label: t("employees.columnNumber") },
          { key: "name", label: t("employees.columnName"), render: (row) => displayEmployeeName(row) },
          { key: "jobDescription", label: t("employees.columnRole") },
          {
            key: "actions",
            label: t("common.actions"),
            render: (row) => (
              <CwRowActions
                onEdit={() => {
                  setEditing(row)
                  setOpen(true)
                }}
                onDelete={() => undefined}
              />
            ),
          },
        ]}
        rows={seed}
      />
      <EmployeeFormModal
        isOpen={open}
        companyId={12}
        employee={editing}
          onClose={() => {
            setOpen(false)
            setEditing(null)
          }}
          onSaved={() => {
            setOpen(false)
            setEditing(null)
          }}
      />
    </div>
  )
}
